





















































import Vue from "vue"
import SessionChangeLog from "@/model/entity/activity-history/session-change-log"
import LoginAsOtherLog from "@/model/entity/activity-history/login-as-other-log"
import ActivityHistoryLog from "@/model/entity/activity-history/activity-history-log"


const detailLog = Vue.extend({
  props: {
    activity:  {
      type:  Object as () => ActivityHistoryLog,
      required: true
    }
  },
  computed: {
    username() {
      const vm = this as any
      return (vm.activity as unknown as ActivityHistoryLog).activityHistory.employee.username
    },
    dateAndTime() {
      const vm = this as any
      return (vm.activity as unknown as ActivityHistoryLog).activityHistory.dateAndTime
    },
    isActivityTypeLoggedIntoUser() {
      const vm = this as any
      return vm.activity instanceof LoginAsOtherLog
    },
    isActivityTypeSessionChange() {
      const vm = this as any
      return vm.activity instanceof SessionChangeLog
    },
    loggedIntoUser() {
      const vm = this as any
      return (vm.activity as unknown as LoginAsOtherLog).getloggedUserInfo().username
    },
    userInfo() {
      const vm = this as any
      return (vm.activity as unknown as LoginAsOtherLog).getloggedUserInfo()
    },
    officeInfo() {
      const vm = this as any
      const userData = (vm.activity as unknown as LoginAsOtherLog).getloggedUserInfo()
      return `${userData.officeName} - ${userData.officeStreet} - ${userData.officeHouseNumber}, ${userData.officeCity}, ${userData.officeZip}`
    },
    userCompany() {
      const vm = this as any
      const userData = (vm.activity as unknown as SessionChangeLog).sessionChangeDetail
      if (vm.activity.activityHistory.activityTypeEnum === "OFFICE_EDIT"
      || vm.activity.activityHistory.activityTypeEnum === "PARCEL_RANGE_ADD") {
        return `${vm.activity.office.company.name} (${vm.activity.office.company.id})`
      }
      return `${userData.companyName} (${userData.companyId})`
    },
    actionType() {
      const vm = this as any
      const userData = (vm.activity as unknown as SessionChangeLog)
      return userData.sessionChangeDetail.actionType || userData.activityHistory.activityTypeEnum
    },
    userOffice() {
      const vm = this as any
      const userData = (vm.activity as unknown as SessionChangeLog).sessionChangeDetail
      return `${userData.officeName} - ${userData.officeStreet} - ${userData.officeHouseNumber}, ${userData.officeCity}, ${userData.officeZip}`
    }
  }
})

export default detailLog
